import { useNavigate } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { FaSignOutAlt, FaSpinner } from 'react-icons/fa';
import Button from '@/components/elements/Button';
import Banner from '@/components/elements/Banner';
import HeaderNavigation from '@/components/HeaderNavigation';
import { HamburgerToggle } from '@/components/HamburgerToggle';
import AccountManagementDropdown from '@/components/AccountManagementDropdown';
import { useMobileNavigation } from '@/state/MobileNavigationContext';
import { trackCustomEvent } from '@/lib/appInsights';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useAuthActions } from '@/hooks/useAuthActions';
import { useLatestArticleByPage } from '@/hooks/useLatestArticleByPage';
import { authenticatedItemsMobile, authenticatedItemsDesktop } from '@/constants/navigation-items';
import { TrackingCustomEvents } from '@/constants/constants';

function PageHeader() {
  const desktopBreakpoint = 920;
  const isMobile = useIsMobile(desktopBreakpoint);
  const navigate = useNavigate();
  const { handleLogout } = useAuthActions();
  const { isOpen, setIsOpen } = useMobileNavigation();
  const { latestArticle, isSubscribePage, isArticlePage } = useLatestArticleByPage();

  function handleBannerClick() {
    trackCustomEvent(TrackingCustomEvents.click.cta.latestArticle, {
      articleId: latestArticle?.id.toString() ?? '',
      articleTitle: latestArticle?.title ?? '',
    });
    navigate(latestArticle ? `/article/${latestArticle.id}` : '#');
  }

  return (
    <header
      data-cy='page-header'
      className='bg-white h-[64px] desktopNav:h-[72px] fixed w-full z-40 top-0 start-0 border-b border-gray-200 flex items-center print:relative print:border-none'
    >
      <div className='w-full relative desktopNav:container desktopNav:mx-auto px-4 flex flex-nowrap items-center justify-between'>
        <HashLink smooth to='/home' className='flex items-center space-x-3 rtl:space-x-reverse flex-shrink'>
          <img src='/logo-long.png' alt='Eklpix Research Logo' className='max-h-9 desktopNav:max-h-11' />
        </HashLink>

        <div className='flex desktopNav:w-auto'>
          <div className='ml-4 desktopNav:w-auto flex items-center justify-center gap-2'>
            {isMobile ? (
              <Button data-cy='logout-button' variant='gradient' buttonText='Logout' onClick={handleLogout}>
                <FaSignOutAlt size={16} className='ml-2' />
              </Button>
            ) : (
              <AccountManagementDropdown />
            )}
            <HamburgerToggle
              isOpen={isOpen}
              onToggle={() => setIsOpen(!isOpen)}
              className='desktopNav:hidden print:hidden'
            />
          </div>
        </div>
      </div>

      <HeaderNavigation
        isMobile={isMobile}
        variant='nav-bar'
        items={isMobile ? authenticatedItemsMobile : authenticatedItemsDesktop}
      />

      {!isSubscribePage && !isArticlePage && (
        <Banner
          title='Latest'
          className='top-[64px] desktopNav:top-[112px]'
          onClick={handleBannerClick}
          description={latestArticle?.title || <FaSpinner className='size-3 inline animate-spin mb-[1px]' />}
        />
      )}
    </header>
  );
}

export default PageHeader;
